 export const CARD_ITEMS = [
    {
      name: "DataQueue Team",
      role: "",
      image:
        "https://cdn.prod.website-files.com/66917442e22cc2364436ff90/669637dda23a325832c9e297_Untitled%20design%20-%202024-07-16T120521.198.png",
      testimonial:
        "Using Audino, the DataQueue Team was able to develop the most accurate Arabic ASR model — all thanks to its intuitive design and robust feature set.",
      rating: 5,
    },
    // {
    //   name: "Michael Chen",
    //   role: "Audio Engineer",
    //   company: "SoundWave Studios",
    //   image:
    //     "/img/c2.avif",
    //   testimonial:
    //     "The precision and clarity we've achieved with Audino's technology has elevated our production quality to new heights.",
    //   rating: 5,
    // },
    // {
    //   name: "Emma Rodriguez",
    //   role: "Content Creator",
    //   company: "Digital Media Co",
    //   image:
    //     "/img/c3.avif",
    //   testimonial:
    //     "As a content creator, Audino has been a game-changer for my workflow. The results are consistently impressive.",
    //   rating: 5,
    // },
    // {
    //   name: "David Kim",
    //   role: "Music Producer",
    //   company: "BeatMakers",
    //   image:
    //     "/img/c4.avif",
    //   testimonial:
    //     "The AI-powered features have revolutionized how we approach audio production. Simply outstanding!",
    //   rating: 5,
    // },
    // {
    //   name: "Lisa Patel",
    //   role: "Podcast Host",
    //   company: "VoiceCast Network",
    //   image:
    //     "/img/c5.avif",
    //   testimonial:
    //     "Audino's noise reduction and voice enhancement features have made our podcast sound professional-grade.",
    //   rating: 5,
    // },
  ];
